module.exports = __webpack_public_path__ + "static/media/algorand_white.611ca289.png";